/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isscreensharingallowed3Inputs */

const en_entity_isscreensharingallowed3 = /** @type {(inputs: Entity_Isscreensharingallowed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Screen Sharing Allowed`)
};

const de_entity_isscreensharingallowed3 = /** @type {(inputs: Entity_Isscreensharingallowed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildschirmfreigabe erlaubt`)
};

/**
* | output |
* | --- |
* | "Is Screen Sharing Allowed" |
*
* @param {Entity_Isscreensharingallowed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isscreensharingallowed3 = /** @type {((inputs?: Entity_Isscreensharingallowed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isscreensharingallowed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isscreensharingallowed3(inputs)
	return de_entity_isscreensharingallowed3(inputs)
});
export { entity_isscreensharingallowed3 as "entity_isScreenSharingAllowed" }